export class PatientHealthcareAgreementRequest {
    public idPatientHealthcareAgreement: number;
    public idHealthcareAgreement: number;
    public idHealthcareAgreementPlan: number;
    public healthcareAgreementCardNumber: string;
    public healthcareAgreementExpirationDate: Date;
}